/** Design tokens + gateway catalog for PayConnect cards. */

import {PAY_CONNECT_CDN_LOGOS} from '../../constants/payConnectCdnLogos'

export const PAYMENT_COLORS = {
  primary: '#2D5DB8',
  success: '#10B981',
  error: '#EF4444',
  warning: '#F59E0B',
  background: '#F9FAFB',
  surface: '#FFFFFF',
  border: '#E5E7EB',
  textPrimary: '#1F2937',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
} as const

export type GatewayFactory = 'PY_WHISH' | 'PY_BLOM_UC' | 'PY_OMT'

export type GatewayCatalogItem = {
  factory_name: GatewayFactory
  brandColor: string
  logo: string
  logoFallback: string
  nameKey: string
  typeKey: string
  descriptionKey: string
  icon: 'wallet' | 'credit-card'
}

export const GATEWAY_CATALOG: GatewayCatalogItem[] = [
  {
    factory_name: 'PY_WHISH',
    brandColor: '#2D9CDB',
    logo: PAY_CONNECT_CDN_LOGOS.PY_WHISH,
    logoFallback: PAY_CONNECT_CDN_LOGOS.PY_WHISH,
    nameKey: 'payment.gateway.whish.name',
    typeKey: 'payment.gateway.whish.type',
    descriptionKey: 'payment.gateway.whish.description',
    icon: 'wallet',
  },
  {
    factory_name: 'PY_BLOM_UC',
    brandColor: '#E31937',
    logo: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    logoFallback: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    nameKey: 'payment.gateway.blom.name',
    typeKey: 'payment.gateway.blom.type',
    descriptionKey: 'payment.gateway.blom.description',
    icon: 'credit-card',
  },
  {
    factory_name: 'PY_OMT',
    brandColor: '#8B5CF6',
    logo: PAY_CONNECT_CDN_LOGOS.PY_OMT,
    logoFallback: PAY_CONNECT_CDN_LOGOS.PY_OMT,
    nameKey: 'payment.gateway.omt.name',
    typeKey: 'payment.gateway.omt.type',
    descriptionKey: 'payment.gateway.omt.description',
    icon: 'wallet',
  },
]

export function getGatewayCatalog(factoryName: string): GatewayCatalogItem | undefined {
  return GATEWAY_CATALOG.find((item) => item.factory_name === factoryName)
}

export type CredentialFieldDef = {
  key: string
  labelKey: string
  inputType?: 'text' | 'password'
}

/** Field keys match existing vendor-api / PayConnect contract. */
export const CREDENTIAL_FIELDS_BY_FACTORY: Record<string, CredentialFieldDef[]> = {
  PY_WHISH: [
    {key: 'channel', labelKey: 'payment.modal.credential_channel_id', inputType: 'text'},
    {key: 'secret', labelKey: 'payment.modal.credential_secret_key', inputType: 'password'},
  ],
  PY_BLOM_UC: [
    {key: 'merchant_key', labelKey: 'payment.modal.credential_merchant_id', inputType: 'text'},
    {key: 'secret_key', labelKey: 'payment.modal.credential_secret_key', inputType: 'password'},
  ],
  PY_OMT: [
    {key: 'username', labelKey: 'payment.modal.credential_api_key', inputType: 'text'},
    {key: 'password', labelKey: 'payment.modal.credential_secret_key', inputType: 'password'},
  ],
}
